<template>
    <g :class="{ 'person': true, 'self': isself, 'passthrough': objectMode == 2}">
        
        <text class="name" text-anchor="middle" :x="metadata.x" :y="metadata.y+42" v-if="isOnScreen">{{ metadata.name }}</text>

        <circle v-if="!isOnScreen" :cx="offscreenPosition.x" :cy="offscreenPosition.y" r="27" :fill="metadata.color" opacity="0.3" :title="metadata.name"></circle>
        <circle v-if="!isOnScreen" :cx="offscreenPosition.x" :cy="offscreenPosition.y" :r="Math.min(1/Math.sqrt(offscreenPosition.distance)*100 || 27, 27)" :fill="metadata.color" opacity="0.8" :title="metadata.name"></circle>

        <g :class="{'pointer': true, 'dragging': metadata.pointer!=undefined }" v-if="pointer != undefined && (objectMode != 2 || metadata.pointer != undefined)" :transform="`translate(${metadata.x}, ${metadata.y})`"  style="translateZ(0)">
            <g :transform="`rotate(${pointer.angle*180/Math.PI+90})`"  style="translateZ(0)">
                <path v-if="metadata.pointer != undefined" :d="`M0 0 l0 ${-pointer.distance+10}`" :stroke="strokeColor" stroke-width="3" stroke-dasharray="7 7"></path>
                
                <circle v-if="pointer.type == 'hold'" :cy="-pointer.distance" r="10" fill="none" :stroke="strokeColor" stroke-width="3"></circle>
                <g v-else :transform="`translate(-13, ${-pointer.distance})`" style="translateZ(0)" :opacity="pointer.opacity || 1">
                    <svg width="26" height="26" viewBox="-4 -4 78 82" :fill="metadata.color" xmlns="http://www.w3.org/2000/svg" :style="
                    metadata.pointer != undefined ? {
                        'stroke': strokeColor,
                        'stroke-width': 8
                    } : {}
                    ">
                        <path d="M28.6695 4.41465L1.41385 62.1706C-1.39872 68.1306 5.0533 74.7979 11.3108 72.7302C18.9427 70.2082 27.7074 68 35 68C42.2926 68 51.0573 70.2082 58.6892 72.7302C64.9467 74.7979 71.3987 68.1306 68.5861 62.1706L41.3305 4.41464C38.8057 -0.935455 31.1943 -0.935448 28.6695 4.41465Z"/>
                    </svg>

                    <!-- makes touch area larger for pointer, easier to grab on mobile -->
                    <circle @mousedown="startDragPointer" @touchstart="startDragPointer" cx="13" cy="14" r="18" fill="transparent"></circle>
                </g>
            </g>
        </g>

        <!--<text text-anchor="middle" :x="metadata.x" :y="metadata.y-40" font-family="Roboto Condensed" font-size="15px" fill="black">{{ emote }}</text>-->

        <foreignObject class="messageObject" :x="metadata.x-80" :y="metadata.y-30" width="160px">
            <!--<div v-html="emote"></div>-->
            <div>
                <div v-for="message in metadata.messages" v-if="Date.now() < message.received + message.lifetime + 600">
                    <div :class="{
                        'message': true,
                        'fade-out': Date.now() > message.received + message.lifetime
                    }">
                        {{ message.text }}
                    </div><br>
                </div>
            </div>
        </foreignObject>

        
        <g :class="{'player': true, 'dragging': dragging}" @mousedown="startDrag" @touchstart="startDrag" v-if="isOnScreen">
            <circle  :cx="metadata.x" :cy="metadata.y" r="27" :fill="metadata.color" :stroke="strokeColor" stroke-width="4"  style="translateZ(0)"></circle>
            <!--<circle :cx="facePosition.x" :cy="facePosition.y" r="10" fill="rgba(0,0,0,0.3)"></circle>-->
            
            <!--<text v-if="isVIP" class="vip" text-anchor="middle" :x="metadata.x" :y="metadata.y+5">VIP</text>-->

            <g class="face">
                <!-- emoji/text -->
               <!--foreignObject :x="metadata.x" :y="metadata.y-60" v-html="emote">

                </foreignObject> -->
                <!-- eyes -->
                <g class="eyes">
                    <circle :cx="facePosition.x-5" :cy="facePosition.y-5" r="2.5" fill="#000000"></circle>
                    <circle :cx="facePosition.x+5" :cy="facePosition.y-5" r="2.5" fill="#000000"></circle>

                    <!--<svg :x="facePosition.x-11.5" :y="facePosition.y-11.5" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.95497 9.57536L7.52906 9.84771L7.89203 9.32616L8.27138 8.78107L8.2726 8.77929L8.30966 8.72572C8.95543 7.79215 9.53677 6.95172 9.91012 6.19243C10.2951 5.40955 10.5223 4.59076 10.2941 3.7393C9.91406 2.32078 8.44488 1.59655 7.05073 1.97011C6.50473 2.11641 6.01669 2.42134 5.64908 2.82441C5.12919 2.65914 4.55407 2.63908 4.00807 2.78539C2.61392 3.15895 1.70369 4.52075 2.08378 5.93926C2.31193 6.79073 2.91813 7.38624 3.64303 7.87147C4.34831 8.34355 5.27542 8.78116 6.30509 9.26717L6.35305 9.28981L6.35436 9.29043L6.95497 9.57536Z" fill="#D50000" stroke="black" stroke-width="1.5"/>
                    </svg>-->

                </g>
                
                <!-- mouth -->
                <!--<path :d="`M ${facePosition.x-4} ${facePosition.y+4} l 8 0`" stroke="#000000" stroke-width="2"></path>-->
                <!--<foreignObject :x="facePosition.x-6" :y="facePosition.y-2" width="12" :height="Math.round((1.3 + (1/(1+Math.pow(Math.E, -audioMeter*9))-0.5) * 20)*10)/10" style="background: #000000">

                </foreignObject>-->
                
                
                <ellipse v-if="!metadata.muted && audioTrackExists/* && mouthSize > 0.4*/" :cx="facePosition.x" :cy="facePosition.y+4" rx="6" :ry="1+mouthSize"></ellipse>
                
                <!--<path v-if="!metadata.muted && mouthSize < 0.6" :transform="`translate(0, ${-2*(smile-mouthSize/128)})`" :d="`
                    M ${facePosition.x-(4 + Math.max((smile-mouthSize/128)*4, mouthSize/128))} ${facePosition.y+4}
                    Q ${facePosition.x} ${facePosition.y+4+10*((smile-mouthSize/128)+0.1)-mouthSize/8} ${facePosition.x+(4 + Math.max((smile-mouthSize/128)*4, mouthSize/32))} ${facePosition.y+4}
                    q ${mouthSize/32} ${mouthSize/16} 0 ${mouthSize/8}
                    Q ${facePosition.x} ${facePosition.y+4+10*((smile-mouthSize/128)+0.1)+mouthSize/4+mouthSize/8} ${facePosition.x-(4 + Math.max((smile-mouthSize/128)*4, mouthSize/32))} ${facePosition.y+4+mouthSize/8}
                    q ${-mouthSize/32} ${-mouthSize/16} 0 ${-mouthSize/8}
                    Z`" stroke="#000000" fill="#000000" stroke-width="2.4" stroke-linejoin="round"/>-->

                <!--<path v-if="!metadata.muted && mouthSize < 0.6" :transform="`translate(0, ${-2*(smile-mouthSize/128)})`" :d="`
                    M ${facePosition.x-4} ${facePosition.y+4}
                    Q ${facePosition.x} ${facePosition.y+4+10*(smile+0.1)} ${facePosition.x+(4 + smile*4)} ${facePosition.y+4}
                    `" stroke="#000000" fill="#000000" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"/>-->
                
                <!--<foreignObject style="overflow:visible;width:1px;height:1px;">
                    <div class="mouthrect" :style="{'transform': `scaleY(${test}) translateZ(0)`}"></div>
                </foreignObject>-->
                <!--<g >
                    <ellipse :transform="`scale(1, ${test})`" v-if="!metadata.muted" :cx="facePosition.x" :cy="facePosition.y+4" rx="6" ry="6"></ellipse>
                </g>-->



                <!--<svg :x="facePosition.x-6.5" :y="facePosition.y+1" width="13" height="6" viewBox="0 0 13 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 6C1.5 6 0 0 0 0H13C13 0 11.5 6 6.5 6Z" fill="black"/>
                </svg>-->

            </g>
        </g>
    </g> 
</template>

<script>
import { mapGetters } from "vuex";
import { angle, distance, getSVGCoordinates, darken } from "@/utils";

import { audioStreamProcessor } from 'audio-stream-meter';

let dragging = {
    id: null, // only id will be self id
    start: {
        mouse: null,
        pos: null
    }
}

export default {
	name: "Person",
    props: ['metadata', 'isself'],
    data() {
        return {
            dragging: false,
            localPointer: null,
            draggingPointer: false,

            gainNode: null,
            pannerNode: null,
            audioMeter: 0,

            smile: 0,
            
            keys: {
                left: null,
                up: null,
                right: null,
                down: null
            },
            lastFrame: Date.now(),
        };
    },
    computed: {
        ...mapGetters(['audioContext', 'getSelf', 'getVIP', 'isMuted', 'emptyStream', 'webAudioOutputStream', 'objectMode', 'view']),
        pointer() {
            return this.metadata.pointer || this.localPointer;
        },
        facePosition() {
            return {
                x: this.metadata.x + (this.metadata.angle != null ? Math.cos(this.metadata.angle) * 13 : 0) * this.metadata.faceDistance,
                y: this.metadata.y + (this.metadata.angle != null ? Math.sin(this.metadata.angle) * 13 : 0) * this.metadata.faceDistance
            }
        },
		volume() {
            return Math.max(Math.min((340 - distance(this.getSelf, this.metadata))/250, 1), 0);
        },
        test() {
            return 0.2 + (1/(1+Math.pow(Math.E, -this.audioMeter*9))-0.5) * 4
        },
        isVIP() {
            return this.metadata == this.getVIP;
        },
        pannerPosition() {
            let d = Math.max(Math.pow(distance(this.metadata, this.getSelf)/200, 2)*200, 200)
            let a = angle(this.getSelf, this.metadata)
            return {
                x: Math.cos(a) * d,
                y: 0,
                z: Math.sin(a) * d
            }
        },
        listenerPositionOrientation() {
            let rad = this.metadata.angle;

            return {
                //x: this.metadata.x/5,
                x: 0,
                y: 0,
                z: 0,
                //z: this.metadata.y/5,
                v1: Math.cos(rad),
                v2: 0,
                v3: Math.sin(rad),
                v4: 0,
                v5: 1,
                v6: 0
            }
        }, 
        mouthSize() {
            /*function map_range(value, low1, high1, low2, high2) {
                return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
            }*/
            return Math.round(((1/(1+Math.pow(Math.E, -this.audioMeter*9))-0.5) * 20)*10)/10
            //console.log(map_range(this.audioMeter, 0.005, 0.1, 0, 1))
            //return (1-Math.pow(1-map_range(this.audioMeter, 0.001, 0.15, 0, 1), 2))*40;
            //return Math.round(((1/(1+Math.pow(Math.E, -this.audioMeter*9))-0.5) * 20)*10)/10
        },
        audioTrackExists() {
            return this.metadata.tracks.audio != undefined
        },
        strokeColor() {
            return darken(this.metadata.color, 0.4)
        },
        isOnScreen() {
            return (this.metadata.x > this.view.x - this.view.width/2  - 27 &&
                    this.metadata.x < this.view.x + this.view.width/2  + 27 &&
                    this.metadata.y > this.view.y - this.view.height/2 - 27 &&
                    this.metadata.y < this.view.y + this.view.height/2 + 27)
        },
        offscreenPosition() {
            if(/*this.isOnScreen*/ true) {
                // // Circular path around center
                // let x = this.view.x + Math.cos(relAngle) * (this.view.width/2 - 10)
                // let y = this.view.y + Math.sin(relAngle) * (this.view.height/2 - 10)

                // Get change
                let x = this.metadata.x - this.view.x;
                let y = this.metadata.y - this.view.y;

                if (x > this.view.width/2) x = this.view.width/2;
                if (y > this.view.height/2) y = this.view.height/2;

                if (x < -this.view.width/2) x = -this.view.width/2;
                if (y < -this.view.height/2) y = -this.view.height/2;

                // Add relative positioning to SVG
                x += this.view.x;
                y += this.view.y;

                // console.log(this.metadata.x - this.view.x,this.metadata.y - this.view.y)
                // console.log(x, y)

                return {
                    x, y, distance: distance(this.view, this.metadata) - distance(this.view, {x, y})
                }
            }
        }
    },
    mounted() {
        if(this.isself) {
            // attach mouse events for dragging
            window.addEventListener('mousemove', this.mouseMove);
            window.addEventListener('mouseup', this.endDrag); // in case drag is not ended by mousemove
            window.addEventListener('touchmove', this.mouseMove);
            window.addEventListener('touchend', this.endDrag);
            window.addEventListener('keydown', this.keyDown);
            window.addEventListener('keyup', this.keyUp);
            this.updateLoop();
        }
    },
    watch: {
        "metadata.tracks.audio": {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (track, oldTrack) {
                if(oldTrack != undefined) {
                    // stop previous track to prevent echo
                    oldTrack.stop();

                    // stop stream processor to fix mouth glitches
                    this.streamProcessor.close();
                }

                if(track != undefined && track.constructor == MediaStreamTrack) {
                    this.connectAudioSource(track);
                }
            }
        },
        "metadata.broadcasting": {
            immediate: true,
            handler (isBroadcasting) {
                if(!this.isself && this.pannerNode) {
                    console.log('UPDATE BROADCASTING')
                    if(isBroadcasting) {
                        this.pannerNode.rolloffFactor = 0.0;
                        this.gainNode.gain.value = 1;
                    } else {
                        this.pannerNode.rolloffFactor = 1.4;
                        this.gainNode.gain.value = 20;
                    }
                }
            }
        },
        /*"volume": {
            immediate: true,
            handler (val, oldVal) {
                if(this.gainNode != undefined) {
                    this.gainNode.gain.value = val;
                }
            }
        },*/
        "pannerPosition": {
            immediate: true,
            handler(pos) {
                if(!this.isself && this.pannerNode) {
                    this.pannerNode.setPosition(pos.x, pos.y, pos.z);
                }
            }
        },
        "listenerPositionOrientation": {
            immediate: true,
            handler(p) {
                if(this.isself) {
                    this.audioContext.listener.setPosition(p.x, p.y, p.z);
                    this.audioContext.listener.setOrientation(p.v1, p.v2, p.v3, p.v4, p.v5, p.v6);
                }
            }
        },
        "isMuted": {
            immediate: true,
            handler(muted) {
                if(this.isself && this.metadata.tracks.audio != undefined) {
                    this.metadata.tracks.audio.enabled = !muted;
                }
            }
        }
    },
    methods: {
        connectAudioSource(track) {
            let stream = new MediaStream();
            //let stream = this.emptyStream.clone();
            //let stream = this.audioContext.createMediaStreamSource();
            stream.addTrack(track);

            // FIXING BUG IN CHROME
            // For some reason the stream will not play any sound unless you feed it through an audio element first?
            /*let a = new Audio();
            a.muted = true;
            a.srcObject = stream;
            a.addEventListener('canplaythrough', () => {
                a = null;
            });*/

            var source = this.audioContext.createMediaStreamSource(stream);

            this.streamProcessor = audioStreamProcessor(this.audioContext, function() {
                //this.audioMeter = this.streamProcessor.volume;
                this.$nextTick(function() {
                    this.audioMeter = this.streamProcessor.volume;
                }.bind(this))
            }.bind(this), { bufferSize: 256, volumeFall: 0.95, throttle: 5 });

            source.connect(this.streamProcessor);
            
            /*if(!this.isself) {
                //var panner = audioContext.createPanner()
                //panner.panningModel = "HRTF"
                
                // Set the 3D position (x, y, z).
                //panner.setPosition(this.metadata.x, 0, this.metadata.y)
                var gainNode = this.audioContext.createGain();
                this.gainNode = gainNode;

                source.connect(gainNode);
                gainNode.connect(this.audioContext.destination);
            }*/

            if(!this.isself) {
                this.pannerNode = this.audioContext.createPanner()
                this.pannerNode.panningModel = "HRTF"

                this.pannerNode.distanceModel = 'exponential';
                this.pannerNode.refDistance = 10;
                //this.pannerNode.maxDistance = 60;
                this.pannerNode.rolloffFactor = 1.4;
                this.pannerNode.coneInnerAngle = 360;
                this.pannerNode.coneOuterAngle = 0;
                this.pannerNode.coneOuterGain = 0;
                
                // Set the 3D position (x, y, z).
                this.pannerNode.setPosition(this.pannerPosition.x, 0, this.pannerPosition.y);
                
                this.gainNode = this.audioContext.createGain();
                this.gainNode.gain.value = 20;
                //this.gainNode = gainNode;

                source.connect(this.gainNode);
                this.gainNode.connect(this.pannerNode);
                //this.pannerNode.connect(this.audioContext.destination);
                this.pannerNode.connect(this.webAudioOutputStream);
            } else {
                let p = this.listenerPositionOrientation;
                this.audioContext.listener.setPosition(p.x, p.y, p.z);
                this.audioContext.listener.setOrientation(p.v1, p.v2, p.v3, p.v4, p.v5, p.v6);
            }
        },
        mouseMove(e) {
            let leftMouseButtonOnlyDown = (e.buttons === undefined ? e.which === 1 : e.buttons === 1) || e.touches != undefined;
            //console.log('mm', e.which, e.buttons, e.touches != undefined)
            
            var cursorpt = getSVGCoordinates(e);

            let dist = distance(this.metadata, cursorpt);

            let lookingAngle = angle(this.metadata, cursorpt);
            //if(dist > 28) {
            if(this.metadata.angle != Math.round(lookingAngle*10)/10) {
                this.$store.dispatch('updateDirection', Math.round(lookingAngle*10)/10);
            }

            let newFaceDistance = Math.round((1 - 1/Math.max(dist/20, 1))*100)/100; // TODO: better decimal function
            if(this.metadata.faceDistance != newFaceDistance) {
                this.$store.dispatch('updateFaceDistance', newFaceDistance);
            }
            //} else {
            //    if(this.metadata.angle != null) {
            //        this.$store.dispatch('updateDirection', null);
            //    }
            //}

            // need to send smile to other participants
            this.smile += distance({x:0, y:0}, {x: e.movementX, y: e.movementY}) / 3000 * Math.pow(1.2 - this.smile, 2);
            
            
            if(dist < 240 && dist > 28) {
                this.localPointer = {
                    distance: 58,
                    angle: lookingAngle,
                    opacity: Math.min((300 - dist)/500, 1)
                }
            } else {
                this.localPointer = null;
            }
            
            // drag player
            if(leftMouseButtonOnlyDown && this.dragging) {
                if(dragging.mouse == null) {
                    dragging.mouse = { x: cursorpt.x, y: cursorpt.y }
                }
                if(dragging.pos == null) {
                    dragging.pos = { x: this.metadata.x, y: this.metadata.y }
                }

                this.$store.dispatch('updatePosition', {
                    x: dragging.pos.x - (dragging.mouse.x - cursorpt.x),
                    y: dragging.pos.y - (dragging.mouse.y - cursorpt.y)
                });
            } else {
                this.dragging = false;
                dragging.mouse = null;
                dragging.pos = null;
            }

            // drag pointer
            if(leftMouseButtonOnlyDown && this.draggingPointer) {
                this.$store.dispatch('updatePointer', {
                    type: 'point',
                    distance: dist,
                    angle: lookingAngle
                });
            } else if(this.draggingPointer) {
                this.draggingPointer = false;

                this.$store.dispatch('updatePointer', null);
            }
        },
        startDrag() {
            if(this.isself) {
                this.dragging = true;
            }
        },
        endDrag() {
            if(this.isself) {
                this.dragging = false;
                this.draggingPointer = false;
                this.$store.dispatch('updatePointer', null);

                dragging.mouse = null;
                dragging.pos = null;
            }
        },
        startDragPointer() {
            if(this.isself) {
                this.draggingPointer = true;
            }
        },
        keyDown(e) {
            /*if(e.keyCode === 37) {
                this.keys['left'] = Date.now()
            }
            if(e.keyCode === 38) {
                this.keys['up'] = Date.now()
            }
            if(e.keyCode === 39) {
                this.keys['right'] = Date.now()
            }
            if(e.keyCode === 40) {
                this.keys['down'] = Date.now()
            }*/

            if(e.keyCode === 192 && this.lastToggledBroadcast == null) { // backtick — broadcasting
                this.$store.dispatch('toggleBroadcast')
                this.lastToggledBroadcast = new Date();
            }
        },
        keyUp(e) {
            /*if(e.keyCode === 37) {
                this.keys['left'] = null
            }
            if(e.keyCode === 38) {
                this.keys['up'] = null
            }
            if(e.keyCode === 39) {
                this.keys['right'] = null
            }
            if(e.keyCode === 40) {
                this.keys['down'] = null
            }*/

            if(e.keyCode === 192 && this.metadata.broadcasting == true && new Date() - this.lastToggledBroadcast > 1300) { // backtick — broadcasting
                this.$store.dispatch('toggleBroadcast');
                this.lastToggledBroadcast = null;
            }
        },
        updateLoop() {
            requestAnimationFrame(this.updateLoop);

            let dt = Date.now() - this.lastFrame;
            this.lastFrame = Date.now();

            this.smile = this.smile * 0.95;

            /*
            let priorityKey = Object.entries(this.keys).filter(a => a[1] != null).sort((a,b) => a[1] > b[1])

            let vec = priorityKey.reduce((vt,k) => {
                let v = {
                    left: { x: -1, y: 0 },
                    up: { x: 0, y: -1 },
                    right: { x: 1, y: 0 },
                    down: { x: 0, y: 1 }
                }[k[0]];

                vt.x += v.x;
                vt.y += v.y;

                return vt;
            }, { x: 0, y: 0 });

            if(vec.x != 0 || vec.y != 0) {
                let a = angle({x: 0, y: 0}, vec);
            
                vec.x = Math.cos(a)
                vec.y = Math.sin(a)
                
                this.$store.dispatch('updatePosition', {
                    x: this.metadata.x + vec.x * dt * 0.15,
                    y: this.metadata.y + vec.y * dt * 0.15
                });
            }*/
        }
    }
};
</script>

<style>
    .person {
        transition: opacity .4s ease-out;
    }
    .self .player { cursor: grab }
    .self .pointer { cursor: move }

    text.name {
        font-size: 14px;
        font-family: "Roboto Condensed";
        user-select:none;
        pointer-events: none;
        text-align: center;
        fill: #FFFFFF;
        stroke: #000000;
        paint-order: stroke;
        stroke-width: 2.5px;
        /*mix-blend-mode: difference;*/
    }

    text.vip {
        font: bold 12px sans-serif;
        user-select:none;
        text-align: center;
        opacity: 0.1;
    }


    .mouthrect {
        width: 6px;
        height: 6px;
        background-color: #000000;
        border-radius: 100%;
        will-change: transform;
        position: absolute;
    }

    .self .player:hover/*, .self .pointer:hover*/ {
        filter: url(#select);
    }
    .self .pointer:not(.dragging):hover g[opacity] {
        opacity: 0.7;
    }

    .player.dragging {
        cursor: grabbing;
    }
    .pointer.dragging {
        filter: none !important;
        cursor: default !important;
    }


    .messageObject {
        overflow: visible;
        height: 1px;
        max-width: 300px;
    }
    .messageObject > div {
        position: absolute;
        left: 0; bottom: 0;
        width: 100%;
        text-align: center;
    }
    .message {
        display: inline-block;
        background-color: #efd9b37c;
        border-radius: 6px;
        margin-top: 1px;
        animation: message 0.5s;
        overflow: hidden;
        padding: 2px 8px;
        opacity: 1;

        overflow-wrap: break-word;
        word-wrap: break-word;
        -ms-word-break: break-all;
        /* This is the dangerous one in WebKit, as it breaks things wherever */
        word-break: break-all;
        /* Instead use this non-standard one: */
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;

        transition: opacity 0.5s ease-out;
    }
    .message.fade-out {
        opacity: 0;
    }
    .messageObject img {
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
    }

    @keyframes message {
        0%   { transform: scale(0); opacity: 0.0; max-height: 0; }
        100% { transform: scale(1.0); opacity:1.0; max-height: 100px; }
    }
</style>